'use es6';

import { ACTION_HUB_OPT_IN, ACTION_USER_OPT_IN } from 'ui-addon-opt/state/OptActions';
import AdditionalOptionsPropType from './AdditionalOptionsPropType';
import { BetaButton } from './BetaButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultOptInButtonText = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "ui-addon-opt.optin.label"
});
const Optin = ({
  additionalOptions,
  dispatch,
  learnMore,
  onLearnMoreClick = emptyFunction,
  onMinimized = emptyFunction,
  onView = emptyFunction,
  optInButtonText = defaultOptInButtonText,
  showHubOptin = false,
  showUserOptin = true
}) => {
  return /*#__PURE__*/_jsx(Dropdown, {
    Button: BetaButton,
    buttonText: optInButtonText,
    onOpenComplete: onView,
    "data-test-id": "dropdown",
    children: /*#__PURE__*/_jsxs(List, {
      "data-test-id": "dropdownList",
      wrapChildren: true,
      children: [showUserOptin && /*#__PURE__*/_jsx(Button, {
        onClick: () => dispatch({
          type: ACTION_USER_OPT_IN
        }),
        "data-test-id": "userOptinButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.optin.options.userOptin"
        })
      }), showHubOptin && /*#__PURE__*/_jsx(Button, {
        onClick: () => dispatch({
          type: ACTION_HUB_OPT_IN
        }),
        "data-test-id": "hubOptinButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.optin.options.hubOptin"
        })
      }), learnMore && /*#__PURE__*/_jsx(Button, {
        href: learnMore.url,
        onClick: onLearnMoreClick,
        target: "_blank",
        "data-test-id": "learnMoreButton",
        children: learnMore.text
      }), additionalOptions && additionalOptions.map(({
        text,
        onClick
      }, idx) => /*#__PURE__*/_jsx(Button, {
        onClick: onClick,
        "data-test-id": `additionalOptionsButton${idx}`,
        children: text
      }, `option-${idx}`)), /*#__PURE__*/_jsx(Button, {
        onClick: onMinimized,
        "data-test-id": "minimizeButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.common.options.minimize"
        })
      })]
    })
  });
};
Optin.propTypes = {
  additionalOptions: AdditionalOptionsPropType,
  dispatch: PropTypes.func.isRequired,
  learnMore: PropTypes.shape({
    text: PropTypes.node.isRequired,
    url: PropTypes.string.isRequired
  }),
  onLearnMoreClick: PropTypes.func,
  onMinimized: PropTypes.func,
  onView: PropTypes.func,
  optInButtonText: PropTypes.node,
  showHubOptin: PropTypes.bool,
  showUserOptin: PropTypes.bool
};
export default Optin;